/* istanbul ignore file */
import React from 'react';

import { Suspense } from '@lumapps/utils/components/Suspense';
import { WidgetSkeletonRectangle } from '@lumapps/widget-base/components/WidgetSkeleton/WidgetSkeletonRectangle';

const LazyBlockComments = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-comments-block-comments' */
            './ConnectedBlockComments'
        ),
);

export const BlockComments = (props: any) => (
    <Suspense loadingFallback={<WidgetSkeletonRectangle style={{ height: '84px' }} useDefaultHeight={false} />}>
        <LazyBlockComments {...props} />
    </Suspense>
);
